export default "images/music.png";